var _fullBleedContainer;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-undef, no-var, object-curly-spacing, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var React = require("react");
var classNames = require("classnames");
var Changeable = require("../mixins/changeable.jsx");
var WidgetJsonifyDeprecated = require("../mixins/widget-jsonify-deprecated.jsx");
var _ = require("underscore");

var ApiClassNames = require("../perseus-api.jsx").ClassNames;
var ApiOptions = require("../perseus-api.jsx").Options;

var _require2 = require("../icon-paths.js"),
    iconCircle = _require2.iconCircle,
    iconCircleThin = _require2.iconCircleThin;

var InlineIcon = require("../components/inline-icon.jsx");
var Renderer = require("../renderer.jsx");
var Util = require("../util.js");
var mediaQueries = require("../styles/media-queries.js");
var sharedStyles = require("../styles/shared.js");

var _require3 = require("../gorgon/proptypes.js"),
    linterContextProps = _require3.linterContextProps,
    linterContextDefault = _require3.linterContextDefault;

var Categorizer = React.createClass({
    displayName: "Categorizer",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: ApiOptions.propTypes,

        // List of categories (across the top)
        categories: React.PropTypes.arrayOf(React.PropTypes.string),
        // List of items that are being categorized (along the left side)
        items: React.PropTypes.arrayOf(React.PropTypes.string),
        trackInteraction: React.PropTypes.func.isRequired,
        // Ordered list of correct answers, mapping items to categories thusly:
        //   values[<items_index>] == <categories_index>
        values: React.PropTypes.arrayOf(React.PropTypes.number),
        linterContext: linterContextProps
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            items: [],
            categories: [],
            values: [],
            linterContext: linterContextDefault
        };
    },

    getInitialState: function getInitialState() {
        return {
            uniqueId: _.uniqueId("perseus_radio_")
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    getUserInput: function getUserInput() {
        return WidgetJsonifyDeprecated.getUserInput.call(this);
    },

    render: function render() {
        var _this = this;

        var self = this;

        // In this context, isMobile is used to differentiate mobile from
        // desktop.
        var isMobile = this.props.apiOptions.isMobile;
        var indexedItems = this.props.items.map(function (item, n) {
            return [item, n];
        });
        if (this.props.randomizeItems) {
            indexedItems = Util.shuffle(indexedItems, this.props.problemNum);
        }

        var table = React.createElement(
            "table",
            { className: "categorizer-table" },
            React.createElement(
                "thead",
                null,
                React.createElement(
                    "tr",
                    null,
                    React.createElement(
                        "th",
                        null,
                        "\xA0"
                    ),
                    this.props.categories.map(function (category, i) {
                        // Array index is the correct key here, as that's
                        // how category grading actually works -- no way
                        // to add or remove categories or items in the
                        // middle. (If we later add that, this should be
                        // fixed.)
                        return React.createElement(
                            "th",
                            { className: css(styles.header), key: i },
                            React.createElement(Renderer, {
                                content: category,
                                linterContext: _this.props.linterContext
                            })
                        );
                    })
                )
            ),
            React.createElement(
                "tbody",
                null,
                indexedItems.map(function (indexedItem) {
                    var item = indexedItem[0];
                    var itemNum = indexedItem[1];
                    var uniqueId = self.state.uniqueId + "_" + itemNum;
                    /* eslint-disable max-len */
                    return React.createElement(
                        "tr",
                        { key: itemNum },
                        React.createElement(
                            "td",
                            null,
                            React.createElement(Renderer, {
                                content: item,
                                linterContext: _this.props.linterContext
                            })
                        ),
                        _.range(self.props.categories.length).map(function (catNum) {
                            var selected = self.props.values[itemNum] === catNum;
                            return React.createElement(
                                "td",
                                {
                                    className: "category " + css(styles.cell, styles.responsiveCell),
                                    key: catNum
                                },
                                React.createElement(
                                    "div",
                                    {
                                        className: ApiClassNames.INTERACTIVE,
                                        onClick: _this.onChange.bind(_this, itemNum, catNum)
                                    },
                                    isMobile && React.createElement("input", {
                                        type: "radio",
                                        name: uniqueId,
                                        className: css(sharedStyles.responsiveInput, sharedStyles.responsiveRadioInput),
                                        checked: selected,
                                        onChange: _this.onChange.bind(_this, itemNum, catNum),
                                        onClick: function onClick(e) {
                                            return e.stopPropagation();
                                        }
                                    }),
                                    !isMobile && React.createElement(
                                        "span",
                                        {
                                            className: css(styles.responsiveSpan, styles.radioSpan, selected && styles.checkedRadioSpan, _this.props.static && selected && styles.staticCheckedRadioSpan)
                                        },
                                        selected ? React.createElement(InlineIcon, iconCircle) : React.createElement(InlineIcon, iconCircleThin)
                                    )
                                )
                            );
                        })
                    );
                    /* eslint-enable max-len */
                })
            )
        );

        // TODO(benkomalo): kill CSS-based styling and move everything to
        // aphrodite.
        var extraClassNames = classNames({
            "categorizer-container": true,
            "static-mode": this.props.static
        });
        var inlineStyles = this.props.apiOptions.isMobile ? [styles.fullBleedContainer] : [];

        return React.createElement(
            "div",
            { className: extraClassNames + " " + css.apply(undefined, inlineStyles) },
            table
        );
    },

    onChange: function onChange(itemNum, catNum) {
        var values = _.clone(this.props.values);
        values[itemNum] = catNum;
        this.change("values", values);
        this.props.trackInteraction();
    },

    simpleValidate: function simpleValidate(rubric) {
        return Categorizer.validate(this.getUserInput(), rubric);
    }
});

_.extend(Categorizer, {
    validate: function validate(state, rubric) {
        var completed = true;
        var allCorrect = true;
        _.each(rubric.values, function (value, i) {
            if (state.values[i] == null) {
                completed = false;
            }
            if (state.values[i] !== value) {
                allCorrect = false;
            }
        });
        if (!completed) {
            return {
                type: "invalid",
                message: i18n._("Make sure you select something for every row.")
            };
        }
        return {
            type: "points",
            earned: allCorrect ? 1 : 0,
            total: 1,
            message: null
        };
    }
});

// TODO(benkomalo): inject page-margin into Perseus instead of hardcoding.
var pageMargin = 16;
var styles = StyleSheet.create({
    fullBleedContainer: (_fullBleedContainer = {}, _fullBleedContainer[mediaQueries.mdOrSmaller] = {
        marginLeft: -pageMargin,
        marginRight: -pageMargin,
        overflowX: "auto"
    }, _fullBleedContainer),

    header: {
        textAlign: "center",
        verticalAlign: "bottom"
    },

    cell: {
        textAlign: "center",
        padding: 0,
        color: "#ccc",
        verticalAlign: "middle"
    },

    radioSpan: {
        fontSize: 30,
        paddingRight: 3,

        ":hover": {
            color: "#999"
        }
    },

    checkedRadioSpan: {
        color: "#333"
    },

    // .static-mode is applied by the Categorizer when the rendered
    // widget is static; in this case we gray out the choices to show
    // the user that the widget can't be interacted with.
    staticCheckedRadioSpan: {
        color: "#888"
    }
});

module.exports = {
    name: "categorizer",
    displayName: "Categorizer",
    widget: Categorizer,
    transform: function transform(editorProps) {
        return _.pick(editorProps, "items", "categories", "randomizeItems");
    },
    staticTransform: function staticTransform(editorProps) {
        return _.pick(editorProps, "items", "categories", "values", "randomizeItems");
    },
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/categorizer.jsx
 ** module id = 94
 ** module chunks = 0 1
 **/